import { IPayment } from '@monetize/types/app';
import {
  ApiListResponse,
  DEFAULT_API_RESPONSE,
  DEFAULT_PAGER,
  FilterType,
  TDataTablePager,
} from '@monetize/types/common';
import { UseQueryOptions } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useGetPaymentsByAccount } from '../../api/accountsService';
import { buildFilterParamsRequestObject } from '../../utils';

export const useAccountPayments = ({
  accountId,
  queryOptions,
}: {
  accountId: string;
  queryOptions?: Partial<
    UseQueryOptions<ApiListResponse<IPayment>, unknown, any>
  >;
}) => {
  const [filters, setFilters] = useState<FilterType[]>([]);
  const [pager, setPager] = useState<TDataTablePager>({
    ...DEFAULT_PAGER,
    sortField: 'paymentDate',
    sortOrder: -1,
  });

  const filterParams = useMemo(
    () => buildFilterParamsRequestObject(filters),
    [filters],
  );

  const {
    isLoading,
    isFetched,
    isRefetching,
    data: payments,
    refetch,
    isError,
    error,
  } = useGetPaymentsByAccount(
    {
      accountId,
      config: pager,
      filters: filterParams,
    },
    {
      meta: { showErrorToast: true },
      placeholderData: (previousData, previousQuery) => previousData,
      ...queryOptions,
    },
  );

  const onResetFilter = () => {
    setFilters([]);
  };

  return {
    pager,
    setPager,
    filters,
    setFilters,
    onResetFilter,
    refetch,
    totalRecords: payments?.totalElements || 0,
    loading: isLoading || (isRefetching && !isFetched),
    listData: payments || DEFAULT_API_RESPONSE,
    isError,
    error,
  };
};
